import { Button } from '@mui/material';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import React from 'react';

const SubmitButton = ({
  label,
  disabled = false,
  height,
  startIcon,
}) => {
  return (
    <React.Fragment>
      <Button
        fullWidth
        variant="contained"
        color="colorPrimer"
        type="submit"
        disabled={disabled}
        sx={{
          height: height || '1.8em',
          minHeight: '40px',
          color: `${themeColors.ColorPrimary} !important`,
          paddingLeft: startIcon ? '.5em' : '',
        }}
        startIcon={startIcon || ''}
      >
        {label}
      </Button>
    </React.Fragment>
  );
};

export default SubmitButton;
